// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2xPQe","clinicsSelect":"TableHeading_clinicsSelect__3qyw3"};